import { ICookieStorageData } from 'amazon-cognito-identity-js';

export const paramCognitoPoolId = process.env.VUE_APP_COGNITOPOOLID || 'COGNITO_POOLID';
export const paramCognitoClientId = process.env.VUE_APP_COGNITOCLIENTID || 'COGNITO_CLIENTID';
export const paramApiGateway = process.env.VUE_APP_APIGATEWAY || 'API_GATEWAY';

export const cookieStorageSettings: ICookieStorageData = {
    domain: location.hostname,
    expires: 1 // 1 days
};

export const emailRegex = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/g;
export const phoneRegex = /\b\d{3}[-.]?\d{3}[-.]?\d{4}\b/g;
export const ssnRegex = /\b\d{3}-\d{2}-\d{4}\b/g;
export const creditCardRegex = [
    /\b\d{4}[- ]?\d{4}[- ]?\d{4}[- ]?\d{4}\b/g, // VISA, Discover, JCB, Master Card
    /\b\d{4}[- ]?\d{6}[- ]?\d{5}\b/g, // AMEX
    /\b\d{4}[- ]?\d{4}[- ]?\d{4}[- ]?\d{2}\b/g // Diners Club card
];
export const ipAddressRegex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/g;

export enum Classifications {
    FOCUSED = 'focused',
    ON_TASK = 'on-task',
    POSSIBLY_OFF_TASK = 'possibly off-task',
    OFF_TASK = 'off task'
}

export enum ClassificationColors {
    FOCUSED = 'teal',
    ON_TASK = 'light-green',
    POSSIBLY_OFF_TASK = 'orange',
    OFF_TASK = 'red'
}

export enum ClassificationThreshold {
    FOCUSED = 0.5,
    ON_TASK = 0.17,
    POSSIBLY_OFF_TASK = 0.1
}
